import React from "react";
import Checkout2 from "../components/Checkout2";

const checkout2 = () => {
  return <Checkout2 />;
};

export default checkout2;
